import { NgModule } from '@angular/core';
import { CockpitChartComponent } from './cockpit-chart.component';

@NgModule({
	declarations: [],
	imports: [CockpitChartComponent],
	exports: [CockpitChartComponent],
})
export class CockpitChartModule {}
